/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { Box, Card, CardContent } from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import "./ContactPage.scss";
import {
  EnterpriseUserDto,
  PortalIssueTypeDto,
  PortalRequestFormDetailsDto,
} from "../../types/User";
import { Select, MenuItem, FormHelperText, InputLabel, Snackbar, Alert } from "@mui/material";
import { userExist, sendHelpDeskRequestForm, getPortalIssueType } from "../../services/userService";
import useApi from "../../hooks/useApi";
import {
  REGEX,
  COMMONCONSTANTS,
  LOCALSTORAGENAME,
  AllowedForLoggedIn,
  AllowedForGuests,
  SEVERITIES,
} from "../../data/constants";
import {
  INSTRUCTION_TEXT,
  ISSUE_SENT,
  ISSUE_SENT_FAIL,
  USERSIGNUPMESSAGES,
} from "../../constants/messages";
import { useUser } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import BackdropProgressBar from "../../components/ui/BackdropProgressBar";
import { logAuditTrace } from "../../services/auditNavigationTraceService";
import { getCurrentESTTime } from "../../utils/dateHelper";

interface ContactPageProps {
  /** Called once the success confirmation is dismissed, so a hosting dialog can close itself. */
  onSubmitSuccess?: () => void;
}

export default function ContactPage({ onSubmitSuccess }: ContactPageProps) {
  const { firstName, lastName, userId, userName } = useUser();
  const [selectedEmailId, setSelectedEmailId] = useState("");
  const navigate = useNavigate();
  const [displayMessage, setDisplayMessage] = useState("");
  const [displaySeverity, setDisplaySeverity] = useState<
    (typeof SEVERITIES)[keyof typeof SEVERITIES]
  >(SEVERITIES.SUCCESS);
  const [helpdeskrequestformDetails, sethelpdeskrequestformDetails] = useState({
    emailOrPhone: "",
    userName: "",
    userFirstName: "",
    userLastName: "",
    userEmail: "",
    userPhone: "",
    issueType: "",
    additionalDetails: "",
    emailMappedTo: "",
  });
  const [readOnlyState, setReadOnlyState] = useState({
    firstName: false,
    lastName: false,
    userPhone: false,
    emailOrPhone: false,
  });
  const [errors, setErrors] = useState({
    emailOrPhoneError: false,
    emailOrPhoneErrorMessage: "",
    userNameError: false,
    userNameErrorMessage: "",
    validationMessage: "",
    requestFormFirstNameError: false,
    requestFormFirstNameErrorMessage: "",
    requestFormLastNameError: false,
    requestFormLastNameErrorMessage: "",
    requestFormemailOrPhoneError: false,
    requestFormemailOrPhoneErrorMessage: "",
    requestForPhoneError: false,
    requestForPhoneErrorMessage: "",
    requestFormIssueTypeError: false,
    requestFormIssueTypeErrorMessage: "",
    requestFormAdditionalDetailsError: false,
    requestFormAdditionalDetailsErrorMessage: "",
  });

  const emailOrPhoneRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  const additionalDetailsRef = useRef<HTMLInputElement>(null);
  const [requestFormSnackbarOpen, setrequestFormSnackbarOpen] = useState<boolean>(false);
  const [state, setState] = useState({
    issueTypeOptions: [] as PortalIssueTypeDto[],
  });
  const { loading, executeApi } = useApi();
  const RequestFormFirstNameRef = useRef<HTMLInputElement>(null);
  const RequestFormLastNameRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (userId && userId > 0) {
      const storedPhone = localStorage.getItem(LOCALSTORAGENAME.PHONENUMBER);
      const storedEmail = localStorage.getItem(LOCALSTORAGENAME.EMAILADDRESS);
      const safePhone =
        storedPhone && storedPhone !== "null" && storedPhone !== "undefined" ? storedPhone : "";
      const safeEmail =
        storedEmail && storedEmail !== "null" && storedEmail !== "undefined" ? storedEmail : "";

      updateRequestFormDetailsState({
        userFirstName: firstName,
        userLastName: lastName,
        userName: userName,
        userPhone: safePhone,
        emailOrPhone: safeEmail,
      });

      setReadOnlyState({
        firstName: !!firstName,
        lastName: !!lastName,
        userPhone: !!safePhone,
        emailOrPhone: !!safeEmail,
      });
    }
  }, [userId]);

  const updateState = <T extends Record<string, unknown>>(
    setState: React.Dispatch<React.SetStateAction<T>>,
  ) => {
    return (newState: Partial<T>) => {
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
    };
  };

  const updateValue = (newState: Partial<typeof state>) => {
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  const updateErrorsState = updateState<typeof errors>(setErrors);
  const updateRequestFormDetailsState = updateState<typeof helpdeskrequestformDetails>(
    sethelpdeskrequestformDetails,
  );

  const handleFormRequestEmailChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputEmail = e.target.value;
    updateRequestFormDetailsState({
      emailOrPhone: inputEmail,
    });
    validateRequestFormEMailOrPhoneField(e.target.value);
  };

  const handleRequestFormFirstNameChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    updateRequestFormDetailsState({ userFirstName: event.target.value });
    validateRequestFormFirstNameField(event.target.value);
  };

  const handleRequestFormPhoneChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    updateRequestFormDetailsState({ userPhone: event.target.value });
    validatePhoneField(event.target.value);
  };

  const handleRequestFormAdditionalDetailsChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    updateRequestFormDetailsState({ additionalDetails: event.target.value });
    validateAdditionalDetailsField(event.target.value, helpdeskrequestformDetails.issueType);
  };

  const handleRequestFormLastNameChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    updateRequestFormDetailsState({ userLastName: event.target.value });
    validateRequestFormLastNameField(event.target.value);
  };

  const validateRequestFormEMailOrPhoneField = (emailOrPhone: string) => {
    let isValid = true;
    if (!emailOrPhone || emailOrPhone.trim() === "") {
      updateErrorsState({
        requestFormemailOrPhoneError: true,
        requestFormemailOrPhoneErrorMessage: USERSIGNUPMESSAGES.FILL_OUT_EMAIL,
      });
      isValid = false;
    } else if (REGEX.EMAIL.test(emailOrPhone)) {
      updateErrorsState({
        requestFormemailOrPhoneError: false,
        requestFormemailOrPhoneErrorMessage: "",
      });
      isValid = true;
    } else {
      updateErrorsState({
        requestFormemailOrPhoneError: true,
        requestFormemailOrPhoneErrorMessage: COMMONCONSTANTS.ENTER_VALID_EMAIL,
      });
      isValid = false;
    }
    return isValid;
  };

  const validatehelpdeskrequestformDetails = async () => {
    let isFirstNameValid = true;
    let isLastNameValid = true;
    let isEmailValid = true;
    let isPhoneValid = true;
    let isIssueTypeValid = true;
    let isAdditionalDetailsValid = true;
    isFirstNameValid = validateRequestFormFirstNameField(helpdeskrequestformDetails.userFirstName);
    isLastNameValid = validateRequestFormLastNameField(helpdeskrequestformDetails.userLastName);
    isEmailValid = validateRequestFormEMailOrPhoneField(helpdeskrequestformDetails.emailOrPhone);
    isPhoneValid = validatePhoneField(helpdeskrequestformDetails.userPhone);
    isIssueTypeValid = validateIssueTypeField(helpdeskrequestformDetails.issueType);
    isAdditionalDetailsValid = validateAdditionalDetailsField(
      helpdeskrequestformDetails.additionalDetails,
      helpdeskrequestformDetails.issueType,
    );
    focusOnRequestFromEmptyField();
    return (
      isFirstNameValid &&
      isLastNameValid &&
      isEmailValid &&
      isPhoneValid &&
      isIssueTypeValid &&
      isAdditionalDetailsValid
    );
  };

  const focusOnRequestFromEmptyField = () => {
    if (!helpdeskrequestformDetails.userFirstName) {
      RequestFormFirstNameRef.current?.focus();
    } else if (!helpdeskrequestformDetails.userLastName) {
      RequestFormLastNameRef.current?.focus();
    } else if (!helpdeskrequestformDetails.emailOrPhone) {
      emailOrPhoneRef.current?.focus();
    } else if (
      isAdditionalDetailsRequired(helpdeskrequestformDetails.issueType) &&
      !helpdeskrequestformDetails.additionalDetails?.trim()
    ) {
      additionalDetailsRef.current?.focus();
    }
  };

  const validateRequestFormFirstNameField = (firstname: string) => {
    let isValid = true;
    if (!firstname || firstname.trim() === "") {
      updateErrorsState({
        requestFormFirstNameError: true,
        requestFormFirstNameErrorMessage: USERSIGNUPMESSAGES.USERFIRSTNAME_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({ requestFormFirstNameError: false, requestFormFirstNameErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };

  const validateIssueTypeField = (issueType: string) => {
    let isValid = true;
    if (!issueType) {
      updateErrorsState({
        requestFormIssueTypeError: true,
        requestFormIssueTypeErrorMessage: USERSIGNUPMESSAGES.IssueType_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({ requestFormIssueTypeError: false, requestFormIssueTypeErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };

  // Bug 77552: Additional Details is mandatory only for the General Question issue type;
  // for Signing Up / Logging In it stays optional.
  const isAdditionalDetailsRequired = (issueType: string) =>
    issueType === COMMONCONSTANTS.ISSUE_TYPE_GENERAL_QUESTION;

  const validateAdditionalDetailsField = (additionalDetails: string, issueType: string) => {
    let isValid = true;
    if (isAdditionalDetailsRequired(issueType) && (!additionalDetails || additionalDetails.trim() === "")) {
      updateErrorsState({
        requestFormAdditionalDetailsError: true,
        requestFormAdditionalDetailsErrorMessage: USERSIGNUPMESSAGES.ISSUE_DESCRIPTION_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({
        requestFormAdditionalDetailsError: false,
        requestFormAdditionalDetailsErrorMessage: "",
      });
      isValid = true;
    }
    return isValid;
  };

  const validatePhoneField = (phone: string) => {
    let isValid = true;
    const phoneRegex = /^[0-9]{10}$/;
    if (phone && !phoneRegex.test(phone)) {
      updateErrorsState({
        requestForPhoneError: true,
        requestForPhoneErrorMessage: COMMONCONSTANTS.ENTER_VALID_PHONE,
      });
      isValid = false;
    } else {
      updateErrorsState({ requestForPhoneError: false, requestForPhoneErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };

  const validateRequestFormLastNameField = (lastname: string) => {
    let isValid = true;
    if (!lastname || lastname.trim() === "") {
      updateErrorsState({
        requestFormLastNameError: true,
        requestFormLastNameErrorMessage: USERSIGNUPMESSAGES.USERLASTNAME_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({ requestFormLastNameError: false, requestFormLastNameErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };

  const handleRequestFormSend = async () => {
    if (!(await validatehelpdeskrequestformDetails())) return;
    const isMail = REGEX.EMAIL.test(helpdeskrequestformDetails.emailOrPhone);
    let isReplyToMe = false;
    if (!isMail) {
      const userDetails = await executeApi<string, EnterpriseUserDto>(
        userExist,
        helpdeskrequestformDetails.emailOrPhone,
      );
      if (userDetails) {
        helpdeskrequestformDetails.emailOrPhone = userDetails.emailAddress;
        isReplyToMe = true;
      }
    } else {
      isReplyToMe = true;
    }
    const portalRequestFormDetailsDto: PortalRequestFormDetailsDto = {
      userName:
        `${helpdeskrequestformDetails.userFirstName} ${helpdeskrequestformDetails.userLastName}`.trim() ||
        helpdeskrequestformDetails.userName,
      email: helpdeskrequestformDetails.emailOrPhone,
      firstName: helpdeskrequestformDetails.userFirstName,
      lastName: helpdeskrequestformDetails.userLastName,
      phone: helpdeskrequestformDetails.userPhone,
      issueName: helpdeskrequestformDetails.issueType,
      additionalDetails: helpdeskrequestformDetails.additionalDetails,
      moduleName: COMMONCONSTANTS.MODULENAME,
      isReplyToMe: isReplyToMe,
      to: helpdeskrequestformDetails.emailMappedTo,
    };
    const issueType = await executeApi<PortalRequestFormDetailsDto, boolean>(
      sendHelpDeskRequestForm,
      portalRequestFormDetailsDto,
    );
    if (issueType) {
      logAuditTrace(
        {
          userId: userId ?? 0,
          objectType: "Page",
          objectId: null,
          objectName: "Contact Support - " + helpdeskrequestformDetails.issueType,
          action: "Contact Support",
          navigationDateTime: getCurrentESTTime(),
        },
        null,
        true,
      );
      setDisplayMessage(ISSUE_SENT(selectedEmailId));
      setDisplaySeverity(SEVERITIES.SUCCESS);
      setrequestFormSnackbarOpen(true);
      // Bug 72996: only clear what the user entered for this request. The identity fields are
      // prefilled from the logged-in user and are not repopulated after mount, so wiping them
      // left the form blank.
      updateRequestFormDetailsState({
        additionalDetails: "",
        issueType: "",
        emailMappedTo: "",
      });
    } else {
      setDisplayMessage(ISSUE_SENT_FAIL(selectedEmailId));
      setDisplaySeverity(SEVERITIES.ERROR);
      setrequestFormSnackbarOpen(true);
    }
  };

  const handleRequestFormSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") return;
    setrequestFormSnackbarOpen(false);
    if (!userId || userId <= 0) {
      navigate("/signin");
    }
    // Bug 72996: close the hosting Contact Support popup once the success confirmation is gone
    // (auto-hide or manual dismiss). Failures keep the popup open so the user can retry.
    if (displaySeverity === SEVERITIES.SUCCESS) {
      onSubmitSuccess?.();
    }
  };

  useEffect(() => {
    const PortalIssueType = async () => {
      const issueType = await executeApi<string, PortalIssueTypeDto[]>(getPortalIssueType, "");
      if (issueType) {
        let filteredOptions = issueType;

        if (userId && userId > 0) {
          filteredOptions = issueType.filter((item) =>
            AllowedForLoggedIn.includes(item.issueType ?? ""),
          );
        } else {
          filteredOptions = issueType.filter((item) =>
            AllowedForGuests.includes(item.issueType ?? ""),
          );
        }
        updateValue({ issueTypeOptions: filteredOptions });
      }
    };
    PortalIssueType();
  }, []);
  // useEffect(() => {
  //   if (state.issueTypeOptions.length === 1 && !helpdeskrequestformDetails.issueType) {
  //     sethelpdeskrequestformDetails((prev) => ({
  //       ...prev,
  //       issueType: state.issueTypeOptions[0].issueType,
  //     }));
  //   }
  // }, [state.issueTypeOptions, helpdeskrequestformDetails.issueType]);
  const applyIssueSelection = (inputIssue: string) => {
    const selectedItem = state.issueTypeOptions.find((item) => item.issueType === inputIssue);

    updateRequestFormDetailsState({
      issueType: inputIssue,
      emailMappedTo: selectedItem?.emailMappedTo || "",
    });

    setSelectedEmailId(selectedItem?.emailMappedTo || "");
    validateIssueTypeField(inputIssue);
    // Switching to an issue type that does not require Additional Details must drop any error
    // raised for the previous type. Switching to one that does require it is not flagged until
    // the user edits the field or submits.
    if (!isAdditionalDetailsRequired(inputIssue)) {
      updateErrorsState({
        requestFormAdditionalDetailsError: false,
        requestFormAdditionalDetailsErrorMessage: "",
      });
    }
  };
  const handleFormRequestIssueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    applyIssueSelection(e.target.value);
  };
  useEffect(() => {
    if (state.issueTypeOptions.length > 0 && !selectedEmailId) {
      setSelectedEmailId(state.issueTypeOptions[0].emailMappedTo ?? "");
    }
  }, [state.issueTypeOptions, selectedEmailId]);

  return (
    <section className="mb-3">
      <Card>
        <CardContent>
          <Box>
            {<BackdropProgressBar loading={loading} />}

            <Box>
              {/* First + Last name */}
              <FormControl fullWidth>
                <Box className="name-fields">
                  <TextField
                    required
                    fullWidth
                    id="firstName"
                    name="firstName"
                    label={COMMONCONSTANTS.FIRSTNAMEPLACEHOLDER}
                    autoComplete="name"
                    variant="outlined"
                    autoFocus
                    value={helpdeskrequestformDetails.userFirstName}
                    onChange={handleRequestFormFirstNameChange}
                    error={errors.requestFormFirstNameError}
                    helperText={errors.requestFormFirstNameErrorMessage}
                    color={errors.requestFormFirstNameError ? "error" : "primary"}
                    inputRef={RequestFormFirstNameRef}
                    size="small"
                    InputProps={{
                      disabled: readOnlyState.firstName,
                    }}
                  />
                  <TextField
                    required
                    fullWidth
                    id="lastName"
                    label={COMMONCONSTANTS.LASTNAMEPLACEHOLDER}
                    name="lastName"
                    autoComplete="name"
                    variant="outlined"
                    value={helpdeskrequestformDetails.userLastName}
                    onChange={handleRequestFormLastNameChange}
                    error={errors.requestFormLastNameError}
                    helperText={errors.requestFormLastNameErrorMessage}
                    color={errors.requestFormLastNameError ? "error" : "primary"}
                    inputRef={RequestFormLastNameRef}
                    size="small"
                    InputProps={{
                      disabled: readOnlyState.lastName,
                    }}
                  />
                </Box>
              </FormControl>

              {/* Email */}
              <FormControl fullWidth sx={{ mb: 2 }}>
                <TextField
                  required
                  fullWidth
                  id="requestFormEmailOrPhone"
                  label={COMMONCONSTANTS.EMAILPLACEHOLDER}
                  name="requestFormEmailOrPhone"
                  autoComplete="email"
                  variant="outlined"
                  value={helpdeskrequestformDetails.emailOrPhone}
                  onChange={handleFormRequestEmailChange}
                  error={errors.requestFormemailOrPhoneError}
                  helperText={errors.requestFormemailOrPhoneErrorMessage}
                  color={errors.requestFormemailOrPhoneError ? "error" : "primary"}
                  inputRef={emailOrPhoneRef}
                  size="small"
                  InputProps={{
                    disabled: readOnlyState.emailOrPhone,
                  }}
                />
              </FormControl>

              {/* Phone */}
              <FormControl fullWidth sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  id="requestFormPhone"
                  label={COMMONCONSTANTS.PHONEPLACEHOLDER}
                  name="requestFormPhone"
                  autoComplete="phone"
                  variant="outlined"
                  value={helpdeskrequestformDetails.userPhone}
                  onChange={handleRequestFormPhoneChange}
                  error={errors.requestForPhoneError}
                  helperText={errors.requestForPhoneErrorMessage}
                  color={errors.requestForPhoneError ? "error" : "primary"}
                  inputRef={phoneRef}
                  size="small"
                  InputProps={{
                    disabled: readOnlyState.userPhone,
                  }}
                />
              </FormControl>

              {/* Issue */}
              <FormControl fullWidth size="small" required sx={{ mb: 2 }}>
                <InputLabel id="demo-simple-select-label">{COMMONCONSTANTS.ISSUE}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  required
                  fullWidth
                  label={COMMONCONSTANTS.ISSUE}
                  id="issueType"
                  name="issueType"
                  variant="outlined"
                  value={helpdeskrequestformDetails.issueType}
                  onChange={handleFormRequestIssueChange}
                  error={errors.requestFormIssueTypeError}
                  color={errors.requestFormIssueTypeError ? "error" : "primary"}
                  size="small"
                >
                  {state.issueTypeOptions.map((item) => (
                    <MenuItem key={item.issueTypeId} value={item.issueType}>
                      {item.issueType}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error>{errors.requestFormIssueTypeErrorMessage}</FormHelperText>
              </FormControl>

              {/* Additional Details */}
              <FormControl fullWidth sx={{ mb: 3 }}>
                <TextField
                  required={isAdditionalDetailsRequired(helpdeskrequestformDetails.issueType)}
                  fullWidth
                  id="additionalDetails"
                  label={COMMONCONSTANTS.ADDITIONALDETAILSPLACEHOLDER}
                  name="additionalDetails"
                  autoComplete="Details"
                  variant="outlined"
                  multiline
                  rows={4}
                  value={helpdeskrequestformDetails.additionalDetails}
                  size="small"
                  onChange={handleRequestFormAdditionalDetailsChange}
                  error={errors.requestFormAdditionalDetailsError}
                  helperText={errors.requestFormAdditionalDetailsErrorMessage}
                  color={errors.requestFormAdditionalDetailsError ? "error" : "primary"}
                  inputRef={additionalDetailsRef}
                />
              </FormControl>

              {/* Submit Button */}
              <Box sx={{ textAlign: "center" }}>
                <Button
                  autoFocus
                  id="helpformsend"
                  variant="contained"
                  sx={{
                    px: 6,
                    bgcolor: "#F57F43",
                    color: "white",
                    "&:hover": {
                      bgcolor: "#F57F43",
                    },
                  }}
                  onClick={handleRequestFormSend}
                >
                  {COMMONCONSTANTS.SEND}
                </Button>
              </Box>

              {selectedEmailId && (
                <Typography
                  variant="body2"
                  sx={{ fontSize: "13px", mt: 2, textAlign: "center", color: "text.secondary" }}
                >
                  {INSTRUCTION_TEXT(selectedEmailId)}
                </Typography>
              )}

              <Snackbar
                open={requestFormSnackbarOpen}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={5000}
                onClose={handleRequestFormSnackbarClose}
              >
                <Alert
                  onClose={handleRequestFormSnackbarClose}
                  severity={displaySeverity}
                  sx={
                    displaySeverity === SEVERITIES.ERROR
                      ? {
                          "& .MuiAlert-icon": { color: "#d32f2f" },
                          "& .MuiAlert-message": { color: "#d32f2f" },
                        }
                      : undefined
                  }
                >
                  {displayMessage}
                </Alert>
              </Snackbar>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </section>
  );
}
